<template>
    <div class="table">
        <!-- <div style="font-size: 13px;color:red">注：每次查询仅限最近30天范围内的统计数据。</div> -->
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="changeSchool">
                        <el-option v-for="item in depts" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div style="display: inline-block; height:40px;">
                <div style="width:310px;">
                    <el-date-picker v-model="form.startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                        style="width: 150px;" type="date" placeholder="开始日期" @change="startDateChangeEvent">
                    </el-date-picker>

                    <el-date-picker v-model="form.endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                        style="width: 150px;" type="date" placeholder="结束日期"
                        :picker-options="limitDate(form.startDate)">
                    </el-date-picker>
                </div>
            </div>

            <div style="display: inline-block; height:40px;">
                <div style="width:150px;">
                    <el-radio-group v-model="form.classModel" @change="getData()">
                        <el-radio-button label="1">行政班</el-radio-button>
                        <el-radio-button label="2">导师班</el-radio-button>
                    </el-radio-group>
                </div>
            </div>

            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.gradeName" placeholder="年级名称，如：四年级" style="width: 160px;"></el-input>
            </div>
            <div style="display: inline-block; height:40px;" v-if="form.classModel == 1">
                <el-input v-model="form.className" placeholder="班级名称，如：3班" style="width: 150px;"></el-input>
            </div>
            <div style="display: inline-block; height:40px;" v-if="form.classModel == 2">
                <el-input v-model="form.mentorName" placeholder="导师班名称" style="width: 150px;"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.queryUserName" placeholder="教师名称" :readonly="true">
                    <el-button slot="append" icon="el-icon-search" @click="findUser()"></el-button>
                </el-input>
            </div>
            <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            <div style="display: block; height:40px; float: right;">
                <el-button type="success" plain @click="queryDate(5)">最近30天 </el-button>
                <el-button type="success" plain @click="queryDate(4)">最近7天</el-button>
                <el-button type="success" plain @click="queryDate(3)">昨天</el-button>
                <el-button type="success" plain @click="queryDate(2)">今天</el-button>
                <el-button type="success" plain @click="queryDate(6)">本周</el-button>
                <el-button type="success" plain @click="queryDate(7)">上周</el-button>
                <el-button type="success" plain @click="queryDate(1)">本月</el-button>
                <el-button type="success" plain @click="queryDate(0)">上月</el-button>
            </div>

            <el-table :data="data" style="width: 100%;margin-bottom: 20px;" row-key="roleId" v-loading="loading"
                :element-loading-text="loadingText" element-loading-spinner="el-icon-loading" border default-expand-all>
                <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="title" label="名称" :show-overflow-tooltip="true" width="130"></el-table-column>
                <el-table-column prop="" label="评分类型" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.scoreType == 1">
                            五育项目
                        </div>
                        <div v-else-if="scope.row.scoreType == 2">
                            复合积分
                        </div>
                        <div v-else-if="scope.row.scoreType == 3">
                            红领巾争章
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="综合比例设置" :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.rateSet != ''">
                            {{ scope.row.rateSet }}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="rangeSet" label="评比范围" :show-overflow-tooltip="true"
                    width="150"></el-table-column>
                <el-table-column prop="name" label="姓名" width="100"></el-table-column>
                <el-table-column prop="gradeName" label="年级名称" width="100"></el-table-column>
                <el-table-column prop="className" label="班级名称" width="100"></el-table-column>
                <el-table-column prop="mentorName" label="导师班名称" width="100"
                    v-if="form.classModel == 2"></el-table-column>
                <el-table-column prop="score" label="值" width="100"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="showData(scope.row)" type="text" size="small"
                            v-if="scope.row.name != '无'">
                            <span style="color: #387EE8;">详情</span>
                        </el-button>
                        <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="handleStudentCount"
                                    v-if="scope.row.name != '无' && form.classModel == 1"
                                    icon="el-icon-circle-check">导出学生统计</el-dropdown-item>
                                <el-dropdown-item command="handleSchoolRuleGroup"
                                    v-if="scope.row.name != '无' && form.classModel == 1"
                                    icon="el-icon-circle-check">导出校规分组</el-dropdown-item>
                                <el-dropdown-item command="handleOtherGroup"
                                    v-if="scope.row.name != '无' && form.classModel == 1"
                                    icon="el-icon-circle-check">导出其他分组</el-dropdown-item>
                                <el-dropdown-item command="handleMentorGroup"
                                    v-if="scope.row.name != '无' && form.classModel == 2"
                                    icon="el-icon-circle-check">导出导师班统计</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 统计详情弹出框 -->
        <div v-if="studentEvaluateInfoVisible">
            <studentEvaluateInfo ref="studentEvaluateInfo"></studentEvaluateInfo>
        </div>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import http from '../../../../common/http';
import studentEvaluateInfo from './StudentEvaluateInfo.vue';
import userTransfer from '../../sys/user/UserTransfer.vue';

export default {
    name: "",
    data() {
        return {
            loading: false,
            loadingText: "",
            studentEvaluateInfoVisible: false,
            transferVisible: false,
            form: {
                id: "",
                deptId: "",
                dateType: 5,
                classModel: "1", // 1-行政班，2-导师班
                mentorName: "", // 导师班名称
                className: "", // 班级名称
                gradeName: "", // 年级名称
                // 时间限制在，查询最多控制在一年内。
                startDate: "",
                endDate: "",
                queryUserId: "",
                queryUserName: "",
            },
            data: [],
            depts: [],
            currUserId: "",
            operatorTip: "平台仅限导出年段和班级的学生报表数据，请在年级名称和班级名称栏输入正确的年级和班级，如：四年级 3班(导师班请输入正确导师班名称)。若要导出年段的数据，只需在年段栏输入正确的年级，班级栏留空。全校的报表导出请钉钉/微信/电话联系17759868903，后台技术支持人员会协助导出Excel报表。"
        }
    },
    components: {
        studentEvaluateInfo, userTransfer
    },
    created: function () {
        this.getDeptData();
        //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
        this.currUserId = JSON.parse(sessionStorage.getItem('userinfo')).id;
    },
    methods: {
        indexMethod(index) {
            return index + 1;
        },
        // 日期限制控制在1年内，查询方法。
        limitDate(sDate) {
            // 管理员是1年内
            let now = new Date(sDate);
            let obj = {
                disabledDate(time) {
                    let parts = sDate.split('-');
                    let date = new Date();
                    date.setFullYear(parts[0]); // 设置年份
                    date.setMonth(parts[1] - 1); // 设置月份（月份从0开始，所以要减1）
                    date.setDate(parts[2] - 1); // 设置日期
                    let startDate = date.getTime()
                    // console.log('结束日期', startDate)
                    // 开始日期的，限制在1年内
                    let endDate = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate()).getTime()
                    return time.getTime() > endDate || time.getTime() < startDate
                }
            }
            return obj
        },
        startDateChangeEvent() {
            // console.log('开始日期变动，触发事件',this.form.startDate)
            this.form.endDate = "";
        },
        getDeptData() {
            //部门管理
            let url = this.listDeptUrl;
            let data = { parentId: "0" };
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.depts = res.data.list;
                    if (this.depts.length > 0) {
                        this.form.deptId = this.depts[0].id;
                    }
                    // 最近30天
                    console.log('查询最近30天')
                    this.queryDate(5);
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            });
        },
        getData() {
            let startDate = this.form.startDate;
            let endDate = this.form.endDate;
            console.log('startDate', startDate);
            console.log('endDate', endDate);

            if (!startDate || !endDate) {
                this.$commonFn.showTip('开始日期或者结束日期不可为空', 3);
                return;
            }

            // 非管理员，年级名称和班级名称不可为空
            // if (this.currUserId != '1') {
            //     if (this.$util.isEmpty(this.form.gradeName)) {
            //         this.$commonFn.showTip(this.operatorTip, 3);
            //         return;
            //     }
            // }


            this.loading = true;
            this.loadingText = "正在加载中...";

            let url = this.honorSetListCountArchiveUrl;
            let data = {
                deptId: this.form.deptId,
                evaluateTarget: 2, // 荣誉目标（1-班级，2-学生）
                startDate: startDate,
                endDate: endDate,
                classModel: this.form.classModel,
                queryGradeName: this.form.gradeName,
                queryMentorName: this.form.mentorName,
                queryClassName: this.form.className,
                queryTeacherId: this.form.queryUserId
            };
            console.log("请求参数：" + JSON.stringify(data));
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.data = res.data.list;
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
                this.loading = false;
            }, (err) => {
                console.log(err);
                this.loading = false;
            });
        },
        // 获取日期
        queryDate(dateType) {
            // this.$forceUpdate();
            this.form.dateType = dateType;
            let url = this.honorSetQueryDateUrl;
            let data = {
                dateType: this.form.dateType //dateType:0-上月，1-本月，2-今天，3-昨天，4-最近7天，5-最近30天
            };
            // console.log(data);
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.form.startDate = res.data.startDate;
                    this.form.endDate = res.data.endDate;
                    // 查询数据
                    this.getData();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
                this.loading = false;
            }, (err) => {
                console.log(err);
                this.loading = false;
            });
        },
        //详情界面
        showData(data) {
            let startDate = this.form.startDate;
            let endDate = this.form.endDate;

            if (!startDate || !endDate) {
                this.$commonFn.showTip('开始日期或者结束日期不可为空', 3);
                return;
            }
            this.studentEvaluateInfoVisible = true;
            this.$nextTick(() => {
                this.$refs['studentEvaluateInfo'].init(data.id, startDate, endDate, this.form);
            })
        },
        // 更多操作触发
        handleCommand(command, row) {
            switch (command) {
                case "handleStudentCount":
                    this.exportExcel(row)
                    break;
                case "handleSchoolRuleGroup":
                    this.exportClassGroupExcel(row, 1)
                    break;
                case "handleOtherGroup":
                    this.exportClassGroupExcel(row, 2)
                    break;
                case "handleMentorGroup":
                    this.exportExcel(row)
                    break;
                default:
                    break;
            }
        },
        // 导出学生统计/导师统计
        exportExcel(row) {
            let startDate = this.form.startDate;
            let endDate = this.form.endDate;

            if (!startDate || !endDate) {
                this.$commonFn.showTip('开始日期或者结束日期不可为空', 3);
                return;
            }

            // 非管理员，年级名称和班级名称不可为空
            // if (this.currUserId != '1') {
            //     if (this.$util.isEmpty(this.form.gradeName)) {
            //         this.$commonFn.showTip(this.operatorTip, 3);
            //         return;
            //     }
            // }

            let url = this.evaluateDetailArchiveExportUrl;
            let param = new URLSearchParams();
            param.append('id', row.id);
            param.append('startDate', startDate);
            param.append('endDate', endDate);
            param.append('sign', 2); // 学生导出标识
            param.append('classModel', this.form.classModel);
            param.append('queryGradeName', this.form.gradeName);
            param.append('queryMentorName', this.form.mentorName);
            param.append('queryClassName', this.form.className);
            param.append('queryTeacherId', this.form.queryUserId);

            let reg = new RegExp('-', 'g')
            let tempStartDate = startDate.replace(reg, '.');
            let tempEndDate = endDate.replace(reg, '.');
            let fileName = "";
            // 1-行政班，2-导师班
            if (this.form.classModel == 1) {
                fileName = row.title + "(" + tempStartDate + "-" + tempEndDate + ")";
            } else if (this.form.classModel == 2) {
                fileName = row.title + "导师班(" + tempStartDate + "-" + tempEndDate + ")";
            }
            // console.log("fileName",fileName);
            // return;
            this.loading = true;
            this.loadingText = "正在导出中，导出过程时间可能会比较长，请耐心等待";
            axios({
                method: "post",
                url: url,
                data: param,
                responseType: "blob"
            }).then(res => {
                const link = document.createElement("a");
                let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", fileName + '.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.loading = false;
            }).catch(error => {
                console.log(error);
                this.loading = false;
            });
        },
        // 导出校规分组/其他分组
        exportClassGroupExcel(row, type) {
            let startDate = this.form.startDate;
            let endDate = this.form.endDate;

            if (!startDate || !endDate) {
                this.$commonFn.showTip('开始日期或者结束日期不可为空', 3);
                return;
            }

            // 非管理员，年级名称和班级名称不可为空
            // if (this.currUserId != '1') {
            //     if (this.$util.isEmpty(this.form.gradeName)) {
            //         this.$commonFn.showTip(this.operatorTip, 3);
            //         return;
            //     }
            // }

            let url = this.evaluateDetailArchiveExportClassGroupUrl;
            let param = new URLSearchParams();
            param.append('id', row.id);
            param.append('startDate', startDate);
            param.append('endDate', endDate);
            param.append('queryGradeName', this.form.gradeName);
            param.append('queryClassName', this.form.className);
            param.append('groupType', type);

            let reg = new RegExp('-', 'g')
            let tempStartDate = startDate.replace(reg, '.');
            let tempEndDate = endDate.replace(reg, '.');
            let fileName = "";
            if (type == 1) {
                fileName = row.title + "校规分组(" + tempStartDate + "-" + tempEndDate + ")";
            } else if (type == 2) {
                fileName = row.title + "其他分组(" + tempStartDate + "-" + tempEndDate + ")";
            }
            // console.log("fileName",fileName);
            // return;
            this.loading = true;
            this.loadingText = "正在导出中，导出过程时间可能会比较长，请耐心等待";
            axios({
                method: "post",
                url: url,
                data: param,
                responseType: "blob"
            }).then(res => {
                const link = document.createElement("a");
                let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", fileName + '.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.loading = false;
            }).catch(error => {
                console.log(error);
                this.loading = false;
            });
        },
        findUser() {
            this.transferVisible = true;
            this.$nextTick(() => {
                if (this.$util.isNotEmpty(this.form.queryUserId)) {
                    let userIdArr = new Array()
                    userIdArr.push(this.form.queryUserId)
                    this.$refs['userTransfer'].init(2, userIdArr, 1, this.form.deptId)
                } else {
                    this.$refs['userTransfer'].init(2, null, 1, this.form.deptId)
                }
            })
        },
        setUser(userId, name) {
            console.log('ID：', userId, "姓名：", name)
            if (this.$util.isEmpty(userId) && this.$util.isEmpty(name)) {
                this.form.queryUserId = ""
                this.form.queryUserName = ""
            } else {
                this.form.queryUserId = userId
                this.form.queryUserName = name
            }
        },
        changeSchool() {
            // 切换学校，清空教师姓名
            this.form.queryUserId = ""
            this.form.queryUserName = ""
        }
    },
    mixins: [http]
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluateArchive/StudentEvaluateCount.vue